import React from 'react';

import Head from 'next/head';

import { Footer } from 'modules/common/Footer';
import { FooterCollection } from 'modules/common/Footer/Footer.types';
import { Header } from 'modules/common/Header';
import { HeaderCollection } from 'modules/common/Header/Header.types';
import { Cases } from 'modules/direct/Cases';
import { CasesDirectCollection } from 'modules/direct/Cases/Cases.types';
import { Faq } from 'modules/direct/Faq';
import { FaqCollection } from 'modules/direct/Faq/Faq.types';
import { Hero } from 'modules/direct/Hero';
import { HeroDirectCollection } from 'modules/direct/Hero/Hero.types';
import { Links } from 'modules/direct/Links';
import { LinksCollection } from 'modules/direct/Links/Links.types';
import { About } from 'modules/plataforma/About';
import { AboutCollection } from 'modules/plataforma/About/About.types';
import { Growth } from 'modules/plataforma/Growth';

import contentfulData from '../services/contentful';
import { queryDirect } from '../services/contentful/querys';

type DirectProps = {
  menuPrincipal: HeaderCollection;
  menuRodape: FooterCollection;
  heroDirect: HeroDirectCollection;
  faqDirect: FaqCollection;
  recursosDirect: LinksCollection;
  aboutDirect: AboutCollection;
  casesDirect: CasesDirectCollection;
};

const Direct = ({
  aboutDirect,
  casesDirect,
  faqDirect,
  heroDirect,
  menuPrincipal,
  menuRodape,
  recursosDirect,
}: DirectProps) => {
  return (
    <div>
      <Head>
        <title>Direct | Olist Vnda - Tecnologia em E-commerce </title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header menus={menuPrincipal.menus} />
      <main>
        <Hero
          title={heroDirect.title}
          description={heroDirect.description}
          image={heroDirect.image}
        />
        <Faq items={faqDirect.items} />
        <Links items={recursosDirect.items} />
        <Growth items={recursosDirect.items} />
        <About
          items={aboutDirect.items}
          title={aboutDirect.title}
          subtitle={aboutDirect.subtitle}
        />
        <Cases items={casesDirect.items} />
      </main>

      <Footer menus={menuRodape.menus} />
    </div>
  );
};

export default Direct;

export async function getServerSideProps() {
  const data = await contentfulData(queryDirect());

  return {
    props: data,
  };
}
